module.exports = __webpack_public_path__ + "static/media/Zyra.3049bbc2.png";